module.exports = __webpack_public_path__ + "img/card-guaranteeDJ.cffcbbe5.svg";